<template>
  <div class="confirmation--invoices">
    <div
      class="confirmation--invoices-record"
      v-for="invoice in invoices"
      :key="`invoice_${invoice.invoiceId}`">
      <ConfirmationSummaryRow
        v-for="invoiceItem in invoice.invoiceItems"
        :key="`invoice_item_${invoiceItem.invoiceItemId}`"
        :label="invoiceItem.serviceName">
        <span v-if="isShowServicePricesEnabled">{{currency(invoiceItem.total)}}</span>
      </ConfirmationSummaryRow>

      <ConfirmationSummaryRow v-if="isShowServicePricesEnabled" label="Tax">
        <span>{{currency(invoice.tax)}}</span>
      </ConfirmationSummaryRow>

      <ConfirmationSummaryRow v-if="isShowServicePricesEnabled" label="TOTAL">
        <span>{{currency(invoice.total)}}</span>
      </ConfirmationSummaryRow>
    </div>
  </div>
</template>

<script>
import { Mixins } from '@spectorasoftware/homegauge-vue';
import ConfirmationSummaryRow from '@/components/ConfirmationSummaryRow.vue';
import FeatureFlagUtil from '@/utilities/feature-flag-util';


const { CurrencyFilter } = Mixins;

export default {
  components: {
    ConfirmationSummaryRow,
  },
  mixins: [CurrencyFilter],
  props: {
    invoices: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      isShowServicePricesEnabled: FeatureFlagUtil.isShowServicePricesEnabled(),
    };
  },
};
</script>
